// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.hour .vpd-time-column:nth-child(1) {\n  width: 100%;\n}\n.hour .vpd-time-column:nth-child(1)::after {\n  content: none;\n}\n.hour .vpd-time-column:nth-child(2) {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
